// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2mLJD","label":"SetPasswdForm_label__Vy1Wj"};